var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"card-body p-0"},[_c('b-row',[_c('b-col',[_c('router-link',{attrs:{"to":{ name: 'ImpactTopic', params: { id: _vm.item.id }}}},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.item.name))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }